import { Box, styled } from '@mui/material';
import { LinkButton } from 'components/contract-detail-panel/styles';
import { ManagementSectionBody, ManagementSectionContainer, ManagementSectionTitle } from '../styles';

export const ContractComplianceContainer = styled(ManagementSectionContainer)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderRadius: '4px',
}));

export const ContractComplianceTitle = styled(ManagementSectionTitle)({
  paddingLeft: '4px',
});

export const ContractComplianceBody = styled(ManagementSectionBody)({
  paddingLeft: '4px',
});

export const HintText = styled('p')(() => ({
  margin: 0,
  fontSize: '13px',
  color: '#6B7280',
}));

export const PanelErrorRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'flex-start',
}));

export const PanelFields = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  // UPInput's field has a fixed height, so an error under it would overlap the next input; let it grow instead
  // (same override as the applicant form's FieldRow).
  '& .MuiTextField-root': {
    height: 'auto',
    minHeight: '49px',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
    WebkitAppearance: 'none',
    margin: 0,
  },
}));

export const RemoveExceptionLink = styled(LinkButton)(() => ({
  alignSelf: 'flex-start',
  padding: '16px 0px 8px',
  '&:disabled': {
    cursor: 'default',
    opacity: 0.5,
  },
}));

export const IntervalRow = styled(Box)(() => ({
  display: 'flex',
  gap: '16px',
  '& > *': {
    flex: 1,
  },
}));

export const SubAreaContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  paddingTop: '16px',
}));

export const RuleCardContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  '& + &': {
    marginTop: '16px',
  },
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '16px',
  padding: '16px',
  backgroundColor: theme.palette.common.white,
  borderRadius: '8px',
}));

export const CardTitle = styled('h2')(() => ({
  margin: '0 0 4px',
  fontSize: '15px',
  fontWeight: 600,
  color: '#111827',
}));

export const DefaultLine = styled(Box)(() => ({
  marginTop: '8px',
  fontSize: '14px',
  color: '#374151',
}));

export const ToolbarRow = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: '16px',
  flexWrap: 'wrap',
}));

/** Wide enough for longer company names while typing (same as feature access). */
export const SearchWrapper = styled(Box)(({ theme }) => ({
  width: '360px',
  maxWidth: '100%',
  '& .MuiTextField-root': {
    width: '100%',
  },
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.common.white,
  },
}));
